import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import CreditsWeb from './Credits.web';
import CreditsMobile from './Credits.mobile';

const CreditsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <CreditsMobile /> : <CreditsWeb isMobile={false} />;
};

export default CreditsScreen;
